// setPostDraftData.js
'use strict';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { FLIX_TITLE_CHARS_MAX } from '../RemoteConfigKeys.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import { PostDraftField } from '../resource/uploadConstants.js';

/**
 * Set post draft data
 * @kind action
 * @param {string} {key} - update key.
 * @param {object} {payload} - payload.
 * @return {Promise} Action promise.
 */
const setPostDraftData =
  ({ key, payload = {} } = {}) =>
  async (dispatch, getState) => {
    const { value, error } = payload;
    if (error) {
      return dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['postDraft', key, 'error'],
          data: {
            i18nKey: error?.i18nKey,
            i18nOption: error?.i18nOption,
          },
        },
      });
    }
    if (PostDraftField.TITLE === key) {
      const maximum = getRemoteConfigData(getState(), FLIX_TITLE_CHARS_MAX);
      return dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['postDraft', key],
          data: {
            value: value?.replace(/[\b]/g, ' ')?.slice(0, maximum),
          },
        },
      });
    }
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['postDraft', key],
        data: {
          value,
        },
      },
    });
  };

export default setPostDraftData;
